module.exports = __webpack_public_path__ + "img/header-icon-1.ae060b8b.png";